module.exports = __webpack_public_path__ + "static/media/atom.eeb67752.svg";